export const COMPANY_INFO = {
  name: "Agora Consulting",
  tagline: "Crafting pathways to prosperity",
  email: "Info@agoraconsulting-et.com",
  phone: "+251 9 09 73 74 75",
  phone2: "+251 9 29 32 34 58",
  address: "Century Executive Tower 13th floor | Bole Atlas",
  poBox: "P.o.Box: 101496",
  city: "Addis Ababa, Ethiopia",
  linkedin: "https://www.linkedin.com/company/agora-consulting-ethiopia",
  twitter: "https://twitter.com/agoraconsulting",
  facebook: "https://www.facebook.com/agoraconsulting",
  founded: "2022",
  copyright:
    "AGORA CONSULTING | © Copyright 2024 | Addis Ababa, Ethiopia. | All Rights Reserved",
  // Standardized logo path for both languages
  logo: "/images/agora.png",
};

export const NAVIGATION = [
  { id: "home", label: "Home", href: "/" },
  { id: "about", label: "About Us", href: "/about" },
  { id: "services", label: "Services", href: "/services" },
  { id: "projects", label: "Projects", href: "/projects" },
  { id: "blog", label: "Blog", href: "/blog" },
  { id: "contact", label: "Contact", href: "/contact" },
];

export const HERO_SLIDES = [
  {
    id: 1,
    label: "Research & Strategy",
    headline: "Crafting Pathways",
    headline2: "to Prosperity",
    subheadline: "Through meticulous research and strategic partnerships",
    description:
      "At Agora Consulting, our commitment lies in crafting pathways to prosperity through meticulous research and strategic partnerships.",
    cta: "Explore Our Work",
    ctaSecondary: "Learn More",
  },
  {
    id: 2,
    label: "Evidence-Based Solutions",
    headline: "From Vision",
    headline2: "to Execution",
    subheadline: "Catalyzing change through evidence-based solutions",
    description:
      "From vision to execution, Agora Consulting catalyzes change through evidence-based solutions and collaborative partnerships.",
    cta: "Our Services",
    ctaSecondary: "Contact Us",
  },
  {
    id: 3,
    label: "Inclusive Development",
    headline: "Transforming",
    headline2: "Challenges",
    subheadline: "Leading towards inclusive and resilient societies",
    description:
      "Transforming challenges into opportunities, Agora Consulting leads the charge towards inclusive and resilient societies.",
    cta: "Get In Touch",
    ctaSecondary: "About Us",
  },
];

export const STATS = [
  { value: 10, suffix: "+", label: "Years of Excellence", icon: "Calendar" },
  { value: 50, suffix: "+", label: "Projects Completed", icon: "CheckCircle" },
  { value: 100, suffix: "+", label: "Expert Researchers", icon: "Users" },
  { value: 15, suffix: "+", label: "Partner Organizations", icon: "Handshake" },
];

export const SERVICES = [
  {
    id: "formative-research",
    icon: "Search",
    number: "01",
    title: "Formative Research",
    shortDesc:
      "Understanding contexts through rigorous data collection and analysis.",
    description:
      "Agora Consulting provides cornerstone formative research services, delving into socio-economic, cultural, and contextual factors shaping development initiatives. Through rigorous data collection and analysis, Agora helps clients understand target populations, pinpoint challenges, opportunities, and priorities. This process refines project objectives, strategies, and implementation to match local realities and stakeholder needs. Leveraging qualitative and quantitative methods like focus groups, interviews, surveys, and participatory techniques, Agora ensures a comprehensive grasp of issues. Insights from this research inform evidence-based decision-making, enabling responsive, impactful intervention design.",
    features: [
      "Qualitative & Quantitative Methods",
      "Focus Groups & Interviews",
      "Participatory Techniques",
      "Evidence-Based Decision Making",
    ],
    color: "from-blue-600 to-blue-800",
    accent: "#3b82f6",
  },
  {
    id: "monitoring-evaluation",
    icon: "BarChart3",
    number: "02",
    title: "Monitoring & Evaluation",
    shortDesc:
      "Comprehensive evaluation of development interventions across sectors.",
    description:
      "Agora Consulting specializes in comprehensive monitoring and evaluation services, evaluating the efficiency, effectiveness, and impact of development interventions across sectors. Through quantitative and qualitative methodologies, Agora conducts rigorous data collection, analysis, and interpretation, providing actionable insights into project performance and outcomes. From baseline assessments to end-of-project evaluations, Agora employs a systematic approach to track progress, identify challenges, and recommend strategic adjustments for optimal implementation and results. Tailored monitoring and evaluation solutions empower clients to make informed decisions, enhance accountability, and improve the effectiveness of their development initiatives.",
    features: [
      "Baseline Assessments",
      "Impact Evaluations",
      "Performance Tracking",
      "Strategic Recommendations",
    ],
    color: "from-amber-500 to-amber-700",
    accent: "#f59e0b",
  },
  {
    id: "third-party-monitoring",
    icon: "Shield",
    number: "03",
    title: "Third-Party Monitoring",
    shortDesc: "Impartial and rigorous assessments ensuring accountability.",
    description:
      "Agora Consulting specializes in Third-Party Monitoring (TPM), offering impartial and rigorous assessments of project activities and outcomes. As an independent entity, Agora plays a crucial role in objectively evaluating the progress and impact of development initiatives, ensuring accountability and transparency. Using both quantitative and qualitative methodologies, Agora conducts comprehensive data collection, analysis, and reporting, providing stakeholders with valuable insights into project performance and effectiveness. With a focus on conflict and post-conflict environments, Agora's TPM services mitigate risks, identify challenges, and maximize intervention impact through evidence-based decision-making and adaptive management strategies.",
    features: [
      "Independent Assessments",
      "Conflict Environment Focus",
      "Risk Mitigation",
      "Transparency & Accountability",
    ],
    color: "from-indigo-600 to-indigo-900",
    accent: "#6366f1",
  },
  {
    id: "capacity-building",
    icon: "GraduationCap",
    number: "04",
    title: "Capacity Building Training",
    shortDesc:
      "Empowering individuals and organizations with essential skills.",
    description:
      "Agora Consulting's Capacity Building Training services are meticulously designed to empower individuals and organizations with the knowledge, skills, and tools needed to navigate complex development landscapes effectively. Through innovative methodologies and tailored curricula, Agora's programs cater to diverse audiences, including governmental institutions, NGOs, private sector entities, and civil society organizations. Whether enhancing project management, refining research methodologies, promoting gender mainstreaming, or fostering entrepreneurship, Agora's expert trainers employ participatory techniques for active engagement and practical learning outcomes. With a commitment to continuous improvement and adaptation, Agora's initiatives serve as catalysts for sustainable capacity building and driving positive socio-economic change.",
    features: [
      "Tailored Curricula",
      "Project Management",
      "Gender Mainstreaming",
      "Entrepreneurship Development",
    ],
    color: "from-emerald-500 to-emerald-800",
    accent: "#10b981",
  },
];

export const WHY_CHOOSE = [
  {
    icon: "Award",
    title: "Expertise & Experience",
    description:
      "With a founder and team boasting extensive experience and expertise across multiple sectors including migration, climate change, governance, and gender, Agora Consulting offers unparalleled insights and solutions to address complex development challenges effectively.",
    color: "#3b82f6",
  },
  {
    icon: "MapPin",
    title: "Local Contextualization",
    description:
      "Agora Consulting combines international standards of quality research with deep-rooted local knowledge and access, ensuring that all solutions are tailored to the specific context and needs of the communities and organizations it serves.",
    color: "#f59e0b",
  },
  {
    icon: "Eye",
    title: "Transparent & Accountable",
    description:
      "As advocates for transparency and accountability, Agora Consulting prioritizes integrity in all its operations. Through impartial third-party monitoring and rigorous evaluation practices, clients can trust that Agora's services uphold the highest standards of ethical conduct.",
    color: "#6366f1",
  },
];

export const TEAM_MEMBERS = [
  {
    id: 1,
    name: "Tewelde Gebremariam",
    role: "Director",
    bio: "Tewelde Gebremariam Adhanom is the founding director of Agora, a research consultancy in Ethiopia focusing on migration, climate change, policy, education, gender, and entrepreneurship. Tewelde has over 10 years of experience in the field of research and is the Director of Communications and a board member for the Ethiopian Evaluation Association (EEvA). Tewelde is experienced in designing, coordinating and leading complex research and monitoring projects across Ethiopia.",
    image: null,
    linkedin: "#",
    areas: ["Migration", "Climate Change", "Policy", "Research Management"],
  },
  {
    id: 2,
    name: "Zerihun Berhane",
    role: "Senior Consultant",
    bio: "Zerihun Berhane has a PhD in local development and global dynamics from the University of Trento, Italy. He has extensive experience in research, training, and capacity building services. His research areas include climate change adaptation, social protection, disaster risk management, food security, poverty, inequality, and migration. Currently serves as Associate Professor at Addis Ababa University and Vice President of the Ethiopian Evaluation Association (EEvA).",
    image: null,
    linkedin: "https://www.linkedin.com/in/zerihun-berhane-70805333/",
    areas: ["Climate Change", "Social Protection", "Impact Evaluation"],
  },
  {
    id: 3,
    name: "Tinsae Kassa",
    role: "Project Manager",
    bio: "Tinsae kassa is a dedicated professional with over five years of experience in project management and field coordination. With a BSc in Public Health and ongoing MSc in Business Administration, Tinsae has a proven track record of leading diverse teams and delivering high-quality results.",
    image: null,
    linkedin: "#",
    areas: ["Project Management", "Data Collection", "Field Coordination"],
  },
  {
    id: 4,
    name: "Kidist Gebrekirstos",
    role: "Data Analyst",
    bio: "Kidist is a Monitoring and Evaluation professional with over four years of experience in project coordination and data collection. Holding BSc and MSc in Economics, Kidist brings strong analytical skills and expertise in the full data cycle from design to reporting.",
    image: null,
    linkedin: "#",
    areas: ["M&E", "Data Analysis", "Economics", "TPM"],
  },
  {
    id: 5,
    name: "Walelign Dejen",
    role: "Operation Manager",
    bio: "Experienced operations manager ensuring smooth project delivery and organizational efficiency across all Agora Consulting initiatives.",
    image: null,
    linkedin: "#",
    areas: ["Operations", "Project Delivery"],
  },
  {
    id: 6,
    name: "Melat Aregay",
    role: "Finance and Admin Manager",
    bio: "Dedicated finance and administration manager overseeing financial operations and administrative processes to support Agora's mission and growth.",
    image: null,
    linkedin: "#",
    areas: ["Finance", "Administration"],
  },
];

export const FAQS = [
  {
    id: 1,
    question:
      "What specific methodologies does Agora Consulting employ in its formative research?",
    answer:
      "Agora Consulting utilizes a variety of qualitative and quantitative research methods, including interviews, surveys, focus groups, and participatory approaches, tailored to the context and objectives of each study.",
  },
  {
    id: 2,
    question:
      "How does Agora Consulting ensure the reliability and validity of its monitoring and evaluation processes?",
    answer:
      "We employ rigorous data collection protocols, use validated instruments, conduct regular quality checks, and follow international M&E standards to ensure the reliability and validity of our processes.",
  },
  {
    id: 3,
    question:
      "Can Agora Consulting provide examples of its past third-party monitoring projects?",
    answer:
      "Yes, we have extensive experience in third-party monitoring including projects with the World Bank's PSNP food distribution monitoring, EU peacebuilding work evaluation, and various humanitarian response assessments across Ethiopia.",
  },
  {
    id: 4,
    question:
      "What types of capacity building training does Agora Consulting offer?",
    answer:
      "We offer customized training programs covering research methodologies, project management, M&E frameworks, gender mainstreaming, data collection techniques, and entrepreneurship development, tailored to organizational needs.",
  },
  {
    id: 5,
    question:
      "How does Agora Consulting ensure cultural sensitivity and community engagement in its research and monitoring activities?",
    answer:
      "We employ local researchers fluent in regional languages, use culturally appropriate methodologies, engage community leaders throughout the process, and ensure that research approaches respect local customs and values.",
  },
  {
    id: 6,
    question:
      "Can Agora Consulting assist with project design and proposal development?",
    answer:
      "Yes, our team can support project design, proposal development, and strategic planning based on our extensive experience and understanding of donor requirements and local contexts.",
  },
  {
    id: 7,
    question:
      "Does Agora Consulting offer ongoing support for project implementation and management?",
    answer:
      "Absolutely. We provide continuous support throughout project lifecycles, including implementation guidance, adaptive management, regular monitoring, and strategic adjustments as needed.",
  },
];

export const BLOG_POSTS = [
  {
    id: 1,
    title: "Understanding Climate-Induced Displacement in the Horn of Africa",
    excerpt:
      "An in-depth analysis of how climate change is reshaping migration patterns and creating new development challenges across the region.",
    category: "Climate Change",
    readTime: "8 min read",
    date: "December 15, 2024",
    image: null,
    tags: ["Climate", "Migration", "Research"],
  },
  {
    id: 2,
    title: "The Role of Third-Party Monitoring in Conflict Settings",
    excerpt:
      "Exploring best practices and methodological innovations in independent project monitoring within fragile and conflict-affected environments.",
    category: "Monitoring",
    readTime: "6 min read",
    date: "November 28, 2024",
    image: null,
    tags: ["TPM", "Conflict", "M&E"],
  },
  {
    id: 3,
    title: "Gender Mainstreaming in Development Programs: A Practical Guide",
    excerpt:
      "A comprehensive guide to effectively integrating gender perspectives into development program design, implementation, and evaluation.",
    category: "Gender",
    readTime: "10 min read",
    date: "November 10, 2024",
    image: null,
    tags: ["Gender", "Development", "Capacity"],
  },
];

export const CLIENTS = [
  "UNHCR",
  "IOM",
  "UNICEF",
  "World Bank",
  "USAID",
  "EU",
  "Save the Children",
  "Oxfam",
  "IRC",
  "Danish Refugee Council",
];

export const PARTNERS = [
  "Addis Ababa University",
  "Ethiopian Policy Studies Institute",
  "African Union",
  "IGAD",
  "GIZ",
  "SIDA",
  "Norwegian Refugee Council",
  "Action Against Hunger",
];
